<template>
  <v-container fluid>
    <FormSubmitPopup
      ref="form"
      :title="$t('buyShipment(s)')"
      v-model="value"
      :rightMethod="onSubmitted"
      @popupClose="$emit('input', false)"
      :rightButtonText="$t('labelSubmit')"
      hasAlert
      large
    >
      <template v-slot:input>
        <v-layout class="subheading" justify-space-between>
          <v-flex m8>
            {{ $t('buyShippingPurchase', { length: Object.keys(orders).length }) }}
            <b>{{ $t('note') }}: </b> {{ $t('USPSLabelCannotBeCanceled') }}
          </v-flex>
          <v-flex md2>
            <v-text-field
              :label="$t('addSearchKeywords')"
              :hint="$t('addSpaceDelimitedKeywords')"
              v-model.trim="keywords"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-data-table
          :headers="headers"
          :items="Object.values(orders)"
          item-key="orderId"
          class="elevation-2 myDense"
          hide-actions
        >
          <template v-slot:items="props">
            <td class="text-xs-left">
              <v-layout> ID: {{ props.item.orderName || props.item.orderId }} </v-layout>
              <!-- <v-flex v-if="Object.values(orders).every(order => !order.isMPS)">
                <ProductWidget
                  :name="props.item.items[0].productName"
                  :sku="[props.item.items[0].sku]"
                />
                <v-layout wrap>
                  <v-flex md6 class="text-sm-left"
                    ><span
                      :style="{
                        color: props.item.items[0].quantityPurchased > 1 ? 'white' : 'black',
                        backgroundColor: props.item.items[0].quantityPurchased > 1 ? 'red' : '',
                      }"
                      >{{ $t('purchased') }}: {{ props.item.items[0].quantityPurchased }}</span
                    ></v-flex
                  >
                  <v-flex md6 class="text-sm-left" pl-3
                    >{{ $t('shipped') }}: {{ props.item.items[0].quantityShipped }}</v-flex
                  >
                </v-layout>
                <v-layout align-center>
                  <v-form :ref="`form-${props.item.orderId}-0`" lazy-validation>
                    <v-flex v-if="JSON.stringify(props.item.selectedDistribution) !== '{}'">
                      <v-text-field
                        :label="
                          $t('toShipProductId', {
                            id: props.item.selectedDistribution.id.slice(-4),
                          })
                        "
                        v-model.number="props.item.toShip"
                        :rules="[
                          fieldIsRequired('to-ship'),
                          fieldIsOverZero('to-ship'),
                          fieldIsInteger('to-ship'),
                          v =>
                            v <= props.item.selectedDistribution.quantity ||
                            $t('toShipQtyExceedsInStockQty'),
                          v =>
                            props.item.items[0].quantityShipped + v <=
                              props.item.items[0].quantityPurchased ||
                            $t('toShipShippedExceedsPurchasedQty'),
                        ]"
                      ></v-text-field>
                    </v-flex>
                  </v-form>
                  <v-flex md1></v-flex>
                  <v-flex md6 v-if="hasHazmatFeatures">
                    <v-checkbox
                      hide-details
                      :label="$t('sendHazmat')"
                      v-model="props.item.isSupportHazmat"
                      class="checkbox"
                      @change="clearFromTemplate(props.item, $event)"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex md6>
                    <v-btn
                      style="margin: 0px"
                      color="primary"
                      flat
                      @click.stop="showAddInventoriesDialog(props.item)"
                      >{{ $t('selectItems') }}</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex> -->
              <v-flex>
                <v-flex v-for="(item, index) in props.item.items" :key="item.orderItemId + index">
                  <v-flex>
                    <ProductWidget :name="item.productName" :sku="[item.sku]" />
                    <v-layout wrap>
                      <v-flex md6 class="text-sm-left">
                        <span
                          :style="{
                            color: item.quantityPurchased > 1 ? 'white' : 'black',
                            backgroundColor: item.quantityPurchased > 1 ? 'red' : 'white',
                          }"
                          >{{ $t('purchased') }}: {{ item.quantityPurchased }}</span
                        >
                      </v-flex>
                      <v-flex md6 class="text-sm-left" pl-3
                        >{{ $t('shipped') }}: {{ item.quantityShipped }}</v-flex
                      >
                    </v-layout>
                    <v-layout wrap v-if="item.selectedDistribution && item.selectedDistribution.siteName">
                      <v-flex md6 class="text-sm-left">
                        <span>{{ $t('warehouseSite') }}: {{ item.selectedDistribution.siteName }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout align-center>
                      <v-form :ref="`form-${props.item.orderId}-0`" lazy-validation>
                        <v-flex v-if="JSON.stringify(item.selectedDistribution) !== '{}'">
                          <v-text-field
                            :label="
                              $t('toShipProductId', { id: item.selectedDistribution.id.slice(-4) })
                            "
                            v-model.number="item.toShip"
                            :rules="[
                              fieldIsRequired('to-ship'),
                              fieldIsOverZero('to-ship'),
                              fieldIsInteger('to-ship'),
                              v =>
                                v <= item.selectedDistribution.quantity ||
                                $t('toShipQtyExceedsInStockQty'),
                              v =>
                                item.quantityShipped + v <= item.quantityPurchased ||
                                $t('toShipShippedExceedsPurchasedQty'),
                            ]"
                          ></v-text-field>
                        </v-flex>
                      </v-form>
                      <v-flex md1></v-flex>
                      <v-flex md6 v-if="hasHazmatFeatures">
                        <v-checkbox
                          hide-details
                          :label="$t('sendHazmat')"
                          v-model="props.item.isSupportHazmat"
                          class="checkbox"
                          @change="clearFromTemplate(props.item, $event)"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex md6>
                        <v-btn
                          style="margin: 0px"
                          color="primary"
                          flat
                          @click.stop="showAddInventoriesDialog(props.item, item.sku)"
                          >{{ $t('selectItems') }}</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
              </v-flex>
              <v-layout
                v-if="
                  JSON.stringify(props.item.shipFrom) !== '{}'
                "
                align-center
              >
                {{ $t('shipFrom') }}:
                {{
                  `${props.item.shipFrom.address1} ${props.item.shipFrom.address2}, ${props.item.shipFrom.city}, ${props.item.shipFrom.state} ${props.item.shipFrom.zipCode}`
                }}
                <v-tooltip top>
                  <template v-slot:activator="tooltip">
                    <div v-on="tooltip.on">
                      <v-btn
                        style="margin: 0px"
                        color="primary"
                        icon
                        small
                        flat
                        @click="e => showEditAddressFrom(e, props.item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  {{ $t('changeAddress') }}
                </v-tooltip>
              </v-layout>
              <v-layout v-if="errorMessages[props.item.orderId]">
                <v-flex class="red--text font-weight-bold text-xs-left">
                  {{ errorMessages[props.item.orderId] }}
                </v-flex>
              </v-layout>
              <div v-if="warningMessages[props.item.orderId]">
                <span class="font-weight-bold text-xs-left" style="background-color: yellow">
                  {{ warningMessages[props.item.orderId] }}
                </span>
              </div>
              <v-layout v-if="recommendAddress[props.item.orderId]">
                <v-flex class="font-weight-bold text-xs-left" style="background-color: yellow">
                  <div>{{ $t('recommendAddress') }}: </div>
                  <div>{{ formatRecommendAddress(recommendAddress[props.item.orderId]) }}</div>
                </v-flex>
                <v-btn color="primary" small flat @click="useRecommendAddress(props.item.orderId)">{{$t('apply')}}</v-btn>
              </v-layout>
            </td>
            <td class="text-xs-left">
              <v-form :ref="`form-${props.item.orderId}-1`" lazy-validation>
                <v-layout>
                  <strong>{{ props.item.shipServiceLevel }}</strong>
                </v-layout>
                <v-layout>
                  {{ $t('deliveryBy') }} {{ toDateString(props.item.promiseDate) }}
                </v-layout>
                <v-layout>
                  <strong>{{ $t('recipient') }}:</strong>
                </v-layout>
                <v-layout>
                  {{ props.item.recipientName }}
                </v-layout>
                <v-layout v-if="props.item.toCompanyName">
                  {{ props.item.toCompanyName }}
                </v-layout>
                <v-layout> {{ props.item.shipAddress1 }} {{ props.item.shipAddress2 }} </v-layout>
                <v-layout>
                  {{ props.item.shipCity }} - {{ props.item.shipState }}
                  {{ props.item.shipPostalCode }}
                  <v-tooltip top>
                    <template v-slot:activator="tooltip">
                      <div v-on="tooltip.on">
                        <v-btn
                          style="margin: 0px"
                          color="primary"
                          icon
                          small
                          flat
                          @click="e => showEditAddressTo(e, props.item)"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    {{ $t('changeAddress') }}
                  </v-tooltip>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-autocomplete
                      :items="templates"
                      return-object
                      :label="$t('template')"
                      v-model="props.item.template"
                      persistent-hint
                      @change="event => onSelectTemplate(props.item.orderId, event)"
                      item-text="name"
                      item-value="name"
                    >
                      <template v-slot:append-outer>
                        <v-btn flat icon @click="showTemplateDialog(props.item)">
                          <v-icon color="primary">add</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:item="props">
                        <template>
                          <v-list-tile-content>
                            {{ props.item.name }}
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-tooltip top>
                    <template v-slot:activator="tooltip">
                      <div v-on="tooltip.on">
                        <v-btn color="primary" @click="e => showInstruction(e, props.item)">{{
                          $t('shipmentInstruction')
                        }}</v-btn>
                      </div>
                    </template>
                    <div style="white-space: pre-wrap; word-break: break-word; max-width: 300px">{{ props.item.instruction || `-${$t('noInstruction')}-` }}</div>
                  </v-tooltip>
                  <v-badge
                    :value="!!props.item.dangerousGoods"
                    color="red"
                    overlap
                    v-if="props.item.isSupportHazmat"
                  >
                    <template v-slot:badge>
                      <span></span>
                    </template>
                    <v-btn color="primary" @click="showDangerousGoodsDialog(props.item)">
                      {{ $t('dangerousGoods') }}
                    </v-btn>
                  </v-badge>
                </v-layout>
              </v-form>
            </td>
            <td class="text-xs-left">
              <v-layout v-if="props.item.isMPS">
                <v-flex>
                  <v-layout justify-space-between>
                    <v-flex md5>
                      <v-text-field
                        hide-details
                        :label="$t('PackageTotal')"
                        :value="props.item.isOneRate ? props.item.packageQuantity : props.item.packageTotal"
                        disabled
                        readonly
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex md5 v-if="!props.item.isOneRate">
                      <v-text-field
                        hide-details
                        :label="$t('weightTotal')"
                        disabled
                        v-model.number="props.item.weightLbTotal"
                        readonly
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-space-between><template v-if="!props.item.isOneRate">
                      <v-flex md7>
                        <vite-autocomplete
                          hide-details
                          :items="props.item.packagingSpecs"
                          :label="$t('SelectPackaging')"
                          item-text="packageName"
                          v-model="props.item.packaging"
                          return-object
                          @change="event => props.item.weightLb = event.weight">
                        </vite-autocomplete>
                      </v-flex>
                      <v-flex md4 v-if="props.item.packaging">
                        <v-text-field
                          :label="$t('packageQty')"
                          hide-details
                          :hint="$t('packageQty')"
                          :rules="[fieldIsInteger('packageQty')]"
                          v-model.number="props.item.packaging.packageQuantity"
                          @change="packageQtyChange(props.item)"
                        ></v-text-field
                      ></v-flex>
                    </template>
                    <template v-else>
                      <v-flex md7>
                        <vite-autocomplete
                          :rules="[
                            fieldIsRequired('packagingType')
                          ]"
                          hide-details
                          :label="$t('SelectPackaging')"
                          :items="getFedexPackagings(props.item)"
                          v-model="props.item.packageType"
                          item-text="name"
                          item-value="id"
                        ></vite-autocomplete>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field
                          :label="$t('packageQty')"
                          hide-details
                          :hint="$t('packageQty')"
                          :rules="[fieldIsInteger('packageQty')]"
                          :readonly="true"
                          v-model.number="props.item.packageQuantity"
                        ></v-text-field>
                      </v-flex>
                    </template>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout align-center v-else-if="props.item.isOneRate">
                <v-flex>
                  <vite-autocomplete
                    :rules="[
                      fieldIsRequired('packagingType')
                    ]"
                    class="table-item"
                    hide-details
                    :label="$t('SelectPackaging')"
                    :items="fedexPackagings"
                    v-model="props.item.packageType"
                    item-text="name"
                    item-value="id"
                  ></vite-autocomplete>
                </v-flex>
              </v-layout>
              <v-form :ref="`form-${props.item.orderId}-2`" lazy-validation>
                <template v-if="!props.item.isOneRate">
                  <v-layout>
                    <v-flex>
                      <v-text-field
                        hide-details
                        v-model.number="props.item['weightLb']"
                        :rules="[
                          fieldIsRequired('weight'),
                          fieldIsOverZero('weight'),
                          isMeasurementMetric ? () => true : fieldIsPkgWeight(props.item['isOz']),
                        ]"
                        @change="weightLbChange(props.item)"
                        :label="
                          isMeasurementMetric
                            ? `${$t('weight')}(kg)`
                            : `${$t('weight')}(${
                                props.item['isOz']
                                  ? $t('clickSwitch', { click: 'Oz', change: 'Lbs' })
                                  : $t('clickSwitch', { click: 'Lbs', change: 'Oz' })
                              })`
                        "
                      >
                        <template v-slot:append>
                          <span
                            v-if="!isMeasurementMetric"
                            @click="props.item['isOz'] = !props.item['isOz']"
                            style="cursor: pointer"
                            >{{ props.item['isOz'] ? 'Oz' : 'Lbs' }}</span
                          >
                        </template>
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout align-center>
                    <v-flex xs4 class="mr-3">
                      <v-text-field
                        class="table-item"
                        hide-details
                        v-model.number="props.item.packaging.length"
                        :label="$t('L')"
                        :suffix="sizeSuffix"
                        :rules="[fieldIsRequired('length'), fieldIsOverZero('length')]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4 class="mr-3">
                      <v-text-field
                        class="table-item"
                        hide-details
                        :label="$t('W')"
                        v-model.number="props.item.packaging.width"
                        :suffix="sizeSuffix"
                        :rules="[fieldIsRequired('width'), fieldIsOverZero('width')]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        class="table-item"
                        hide-details
                        :label="$t('H')"
                        v-model.number="props.item.packaging.height"
                        :suffix="sizeSuffix"
                        :rules="[fieldIsRequired('height'), fieldIsOverZero('height')]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1>
                      <PackagingSelector
                        :packagings="packagings"
                        @select="item => onSelectPackaging(item, props.item)"
                      />
                    </v-flex>
                  </v-layout>
                </template>
                <v-layout>
                  <v-flex>
                    <v-select
                      hide-details
                      :items="
                        filterShippingServiceByFromState(
                          shippingServices,
                          props.item.shipFrom.state
                        )
                      "
                      item-text="text"
                      :menu-props="{ returnValue: 'value' }"
                      v-model="props.item.shippingService"
                      :rules="[fieldIsRequired('service'), checkShipForm()]"
                      :label="$t('shippingService')"
                      @change="shippingServiceOnChange(props.item)"
                    >
                      <template v-slot:item="data">
                        <template v-if="isObject(data.item)">
                          <v-list-tile-content v-text="data.item"></v-list-tile-content>
                        </template>
                        <template v-else>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ data.item.text }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-autocomplete
                      :label="$t('serviceType')"
                      v-model="props.item.isExpedited"
                      item-text="label"
                      item-value="value"
                      :items="[
                        { label: $t('normal'), value: false },
                        { label: $t('expedite'), value: true },
                      ]"
                      hide-details
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-select
                      :disabled="!isSupportLabelStockType(props.item.shippingService)"
                      class="table-item"
                      hide-details
                      :label="$t('labelStockType')"
                      :items="labelStockTypes"
                      item-text="text"
                      :menu-props="{ returnValue: 'value' }"
                      v-model="props.item.labelStockType"
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <SelectWidget
                      :label="$t('otherServices')"
                      :items="otherServices"
                      v-model="props.item.selectedOtherServices"
                      itemText="displayName"
                      itemValue="value"
                      chipText="displayName"
                      :displayQty="3"
                      hide-details
                      :mutuallyExclusives="['photo', 'photoForItem']"
                    />
                  </v-flex>
                </v-layout>
              </v-form>
            </td>
            <td class="text-xs-left">
              <v-form :ref="`form-${props.item.orderId}-3`" lazy-validation>
                <v-layout>
                  <v-flex>
                    <v-text-field
                      :label="$t('senderName')"
                      v-model="props.item.senderName"
                      :rules="[fieldIsRequired('sender name'), fieldCharLimit('Sender name', 35)]"
                      prepend-icon="person"
                      hide-details
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-text-field
                      :label="$t('companyName')"
                      v-model="props.item.fromCompanyName"
                      prepend-icon="business"
                      hide-details
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-text-field
                      :value="props.item.shipDate"
                      :label="$t('shipDate')"
                      prepend-icon="event"
                      readonly
                      @click="e => showEditDate(e, props.item)"
                      hide-details
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-text-field
                      hide-details
                      prepend-icon="business_center"
                      :label="$t('declaredValue')"
                      :disabled="!props.item.enableInsured"
                      v-model.number="props.item.insuredValue"
                      :rules="[fieldIsRequired('value'), fieldIsNoLessThanZero('value')]"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-select
                      prepend-icon="bookmarks"
                      :label="$t('signatureService')"
                      :items="getLabelServiceSettingByCarrierAndServiceTypeValue(props.item.carrier, props.item.shippingService).signatureOptions"
                      item-text="text"
                      :menu-props="{ returnValue: 'value' }"
                      hide-details
                      v-model="props.item.signature"
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-text-field
                      :label="$t('memo')"
                      :value="props.item.replacedMemo"
                      @input="value => props.item.memo = value"
                      prepend-icon="note"
                      :rules="[fieldCharLimit('Memo', getCurShippingService(props.item.shippingService).memoLength || 40)]"
                      hide-details
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <template v-if="getCurShippingService(props.item.shippingService).enableReferences">
                  <v-layout>
                    <v-flex>
                      <v-select
                        class="table-item"
                        hide-details
                        :label="$t('referenceType')"
                        :items="referenceOptions"
                        item-text="text"
                        prepend-icon="note"
                        :menu-props="{ returnValue: 'value' }"
                        v-model="props.item.referenceName"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout style="padding-bottom: 10px;">
                    <v-flex>
                      <v-text-field
                        :label="$t('reference')"
                        :disabled="!props.item.referenceName"
                        prepend-icon="note"
                        v-model="props.item.referenceValue"
                        :rules="[fieldCharLimit('reference', getCurShippingService(props.item.shippingService).referenceLength || 40)]"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </template>
              </v-form>
            </td>
            <td class="text-xs-left">
              <v-layout justify-center v-if="isLoadingRates[props.item.orderId]">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-layout>
              <v-layout
                justify-center
                v-else-if="
                  !rates[props.item.orderId] || !Object.keys(rates[props.item.orderId]).length
                "
              >
                $ ----
              </v-layout>
              <v-layout justify-center v-else>
                <v-tooltip top>
                  <template v-slot:activator="tooltip">
                    <div v-on="tooltip.on">${{ rates[props.item.orderId].total }}</div>
                  </template>
                  <b>{{ $t('baseCharge') }}:</b> ${{ rates[props.item.orderId].rate }}
                  <b>{{ $t('surcharge') }}:</b> ${{ rates[props.item.orderId].surcharge }}
                  <b v-if="rates[props.item.orderId].isResidential">{{ $t('residential') }}</b>
                </v-tooltip>
              </v-layout>
              <v-layout justify-center>
                <v-btn color="primary" flat @click.stop="getRate(props.item.orderId)">{{
                  $t('getRate')
                }}</v-btn>
              </v-layout>
              <v-layout justify-center>
                <v-btn
                  icon
                  flat
                  dark
                  color="primary"
                  :disabled="isLoading"
                  @click.stop="removeOrder(props.item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-layout>
            </td>
          </template>
        </v-data-table>
        <v-menu
          v-model="templateMenu"
          :position-x="x"
          :position-y="y"
          absolute
          offset-y
          :close-on-content-click="false"
        >
          <v-card>
            <v-container>
              <v-layout>
                <v-autocomplete
                  style="margin-bottom: 0"
                  :label="$t('instructionTemplate')"
                  @input="changeInstruction"
                  v-model="instructionTemplate"
                  :items="instructions"
                  item-text="name"
                  return-object
                  clearable
                ></v-autocomplete>
              </v-layout>
              <v-layout>
                <v-textarea
                  :label="$t('shipmentInstruction')"
                  outline
                  v-model="instructionInEdit"
                  rows="8"
                  class="thinBox"
                ></v-textarea>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-btn
                color="primary"
                flat
                @click="
                  () => {
                    templateMenu = false
                    instructionInEdit = ''
                  }
                "
                >{{ $t('cancel') }}</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                @click="
                  () => {
                    orderInEdit.instruction = instructionInEdit
                    templateMenu = false
                    instructionInEdit = ''
                  }
                "
                >{{ $t('save') }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-menu
          v-model="addressMenu"
          :position-x="x"
          :position-y="y"
          absolute
          offset-y
          :close-on-content-click="false"
        >
          <v-card>
            <v-card-text>
              <v-form ref="form-address" lazy-validation>
                <v-layout justify-space-between v-if="addressInEditType === 'to'">
                  <v-flex md5>
                    <v-text-field
                      hide-details
                      :label="$t('recipientName')"
                      v-model="addressInEdit.name"
                      :rules="[
                        fieldIsRequired('Recipient name'),
                        fieldCharLimit('Recipient name', 35),
                      ]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md5>
                    <v-text-field
                      :label="$t('companyName')"
                      v-model="addressInEdit.toCompanyName"
                      hide-details
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 1`"
                      v-model="addressInEdit.address1"
                      :readonly="isReadonly"
                      :rules="[fieldIsRequired('Address1'), fieldCharLimit('Address1', 50)]"
                      class="required_field"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 2`"
                      :rules="[fieldCharLimit('Address2', 50)]"
                      v-model="addressInEdit.address2"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex md3>
                    <v-text-field
                      hide-details
                      :label="$t('city')"
                      v-model="addressInEdit.city"
                      :readonly="isReadonly"
                      :rules="[fieldIsRequired('City')]"
                      class="required_field"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md3>
                    <vite-autocomplete
                      hide-details
                      :items="getStates(orderInEdit.shippingService)"
                      v-model="addressInEdit.state"
                      :readonly="isReadonly"
                      :label="$t('state')"
                      :rules="[fieldIsRequired('State')]"
                      class="required_field"
                    >
                      <template v-slot:item="data">
                        <template>
                          <v-list-tile-content>
                            <v-list-tile-title :id="data.item">
                              {{ data.item }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </vite-autocomplete>
                  </v-flex>
                  <v-flex md3>
                    <v-text-field
                      hide-details
                      :label="$t('zipCode')"
                      :readonly="isReadonly"
                      v-model="addressInEdit.zipCode"
                      :rules="[fieldIsRequired('Zip code')]"
                      class="required_field"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between align-baseline>
                  <v-flex md8>
                    <v-layout align-baseline justify-space-between>
                      <v-flex v-bind="{
                        md5: addressInEditType === 'from' && orderInEdit.isSupportFromExt || (addressInEditType === 'to' && orderInEdit.isSupportToExt),
                        md10: addressInEditType === 'from' && !orderInEdit.isSupportFromExt || (addressInEditType === 'to' && !orderInEdit.isSupportToExt)
                      }">
                        <v-text-field
                          :label="$t('phone')"
                          v-model="addressInEdit.phone"
                          hide-details
                        ></v-text-field>
                      </v-flex>
                      <v-flex md3 v-if="addressInEditType === 'from' && orderInEdit.isSupportFromExt || (addressInEditType === 'to' && orderInEdit.isSupportToExt)">
                        <v-text-field
                          :label="$t('extension')"
                          v-model="addressInEdit.extension"
                          :rules="[fieldCharLimit('extension', 6)]"
                          hide-details
                        ></v-text-field>
                      </v-flex>
                      <v-flex md1>
                      </v-flex>
                      <v-flex v-if="isShowApplyToAllBtn">
                        <v-btn
                          color="primary"
                          small
                          dark
                          flat
                          @click="applyPhoneNumberToAll"
                        >
                          {{ $t('applyPhone#ToAll') }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex md5 lg3>
                    <v-btn flat color="primary" @click.stop="goToGoogleMapLink"
                      ><v-icon>location_on</v-icon> {{ $t('googleMap') }}</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-btn color="primary" flat @click="addressMenu = false">{{ $t('cancel') }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                @click="() => (addressInEditType === 'from' ? saveAddressFrom() : saveAddressTo())"
                >{{ $t('save') }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-menu
          :close-on-content-click="false"
          v-model="shipDateMenu"
          :position-x="x"
          :position-y="y"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-date-picker
            v-model="orderInEdit.shipDate"
            @input="shipDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </template>
    </FormSubmitPopup>
    <AddInventories
      :title="$t('selectProduct')"
      v-model="addInventoriesDialog"
      v-if="addInventoriesDialog"
      @showAddProductDialog="item => showAddProductDialog(item)"
      @deleteDistribution="item => deleteProduct(item)"
      @addDistribution="item => addProduct(item)"
      :addedDistributionSet="addedDistributionSet"
      :editMode="true"
      :skus="skus"
      :allDistribution="allDistributionWithCombinedUpcs"
      :isHazmat="hasHazmatFeatures && selectedOrder.isSupportHazmat"
    ></AddInventories>
    <LabelTemplatePopup
      v-model="createTemplateDialog"
      v-if="createTemplateDialog"
      :initTemplate="templateInEdit"
      @submitted="onCreateTemplate"
    />
    <FormSubmitPopup
      :title="$t('dangerousGoods')"
      v-model="dangerousGoodsDialog.show"
      v-if="dangerousGoodsDialog.show"
      :rightMethod="onSubmittedDangerousGoods"
      @popupClose="dangerousGoodsDialog.show = false"
      :rightButtonText="$t('ok')"
      large
    >
      <template v-slot:input>
        <HazardousCommodities
          v-model="dangerousGoodsDialog.data.hazMatsInfo"
          :dangerousGoods.sync="dangerousGoodsDialog.data.dangerousGoods"
          :offerorName.sync="dangerousGoodsDialog.data.offerorName"
          :emergencyContactNumber.sync="dangerousGoodsDialog.data.emergencyContactNumber"
          :dryIceWeight.sync="dangerousGoodsDialog.data.dryIceDetail.weight"
          :dryIceUnit.sync="dangerousGoodsDialog.data.dryIceDetail.unit"
          ref="HazardousCommodities"
        />
      </template>
    </FormSubmitPopup>
  </v-container>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import ProductWidget from './ProductWidget'
import AddInventories from './AddInventories'
import InventoryDetails from './InventoryDetails'
import SelectWidget from './SelectWidget'
import LabelTemplatePopup from './LabelTemplatePopup'
import HazardousCommodities from './HazardousCommodities'
import PackagingSelector from './PackagingSelector'
import {
  timeTools,
  checkRules,
  cloneDeep,
  toMoney,
  uniqueIdGenerator,
  measurementTools,
  isObject,
  gotoGoogleMap,
  labelServiceComponentTools,
  addNumbers,
  findShippingRangeByToShip,
  buildShippingRanges
} from '@/utils/tools'
import measurementMixin from '../mixins/measurement.vue'
import { PRICING_OPTIONS } from '@/utils/const'

export default {
  name: 'BuyShippingPopup',
  components: {
    FormSubmitPopup,
    ProductWidget,
    AddInventories,
    InventoryDetails,
    SelectWidget,
    LabelTemplatePopup,
    HazardousCommodities,
    PackagingSelector
  },
  mixins: [
    checkRules,
    timeTools,
    measurementTools,
    labelServiceComponentTools,
    measurementMixin
  ],
  data () {
    let initOrders = {}
    this.selectedOrders.forEach(order => {
      initOrders[order.orderId] = cloneDeep(order)
      let toShip = {}
      order.isMPS && (initOrders[order.orderId].packagingSpecs = order.packagingSpecs?.map(pkg => {
        return {
          ...pkg,
          ...this.convertPackagingSize(pkg, order.isMeasurementMetric),
          weight: this.convertWeight(pkg.weight, order.isMeasurementMetric)
        }
      }) || [])
      order.items.forEach(item => {
        toShip[item.orderItemId] = item.quantityPurchased - item.quantityShipped
      })
      Object.assign(initOrders[order.orderId], {
        items: order.items.map(item => { return {...item, toShip: item.quantityPurchased, selectedDistribution: {}} }),
        isOz: false,
        weightLb: this.convertWeight(order.isMPS ? order.packagingSpecs?.[0].weight : order.weight || 0, order.isMeasurementMetric),
        packaging: (() =>
          (order.length || order.width || order.height) && (order.isMeasurementMetric !== undefined) ?
            (order.isMPS ? {...this.convertPackagingSize(order, order.isMeasurementMetric),
              ...initOrders[order.orderId].packagingSpecs?.[0]} : this.convertPackagingSize(order, order.isMeasurementMetric)) : {}
        )(),
        insuredValue: order.insuredValue || 0,
        senderName: order.senderName || '',
        fromCompanyName: '',
        toCompanyName: order.buyerCompany || '',
        selectedDistribution: {},
        shipDate: this.toPickerDateString(new Date(order.shipmentDate || new Date().getHours() >= 20 ? Date.now() + 86400000 : Date.now())),
        shipFrom: {},
        isExpedited: false,
        selectedOtherServices: [],
        signature: order.signatureValue,
        shippingService: order.serviceTypeValue || this.$store.getters.labelDefaultService,
        carrier: this.$store.getters.getCarrierByServiceType(order.serviceType) || this.$store.getters.labelDefaultCarrier,
        template: {},
        templateInEdit: {},
        instruction: '',
        to: {},
        toShip,
        replacedMemo: '',
        memo: order.memo || '',
        dangerousGoods: '',
        hazMatsInfo: [],
        offerorName: '',
        emergencyContactNumber: '',
        dryIceDetail: {
          weight: '',
          unit: ''
        },
        labelStockType: 'STOCK_4X6',
        isSupportHazmat: false,
        packageTotal: initOrders[order.orderId].packagingSpecs?.reduce((total, item) => addNumbers(total + item.packageQuantity), 0) || 0,
        weightLbTotal: initOrders[order.orderId].packagingSpecs?.reduce((total, item) =>
          addNumbers(total + (item.weight * item.packageQuantity)), 0) || 0,
        referenceName: '',
        referenceValue: '',
        packageType: '',
        isOneRate: false
      })
    })
    return {
      headers: [
        { text: this.$t('orderDetails'), value: 'orderItemId', align: 'left', sortable: false, width: '30%' },
        { text: this.$t('customerShipOption'), value: 'productName', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('selectedShippingService'), value: '', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('options'), value: '', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '10%' }
      ],
      pagination: {
        rowsPerPage: 20
      },
      addInventoriesDialog: false,
      addProductDialog: false,
      selectedOrder: {},
      serviceType: '',
      newSenderName: '',
      orders: initOrders,
      createTemplateDialog: false,
      errorMessages: {},
      warningMessages: {},
      shipFromFlags: {},
      shipToFlags: {},
      instructionFlags: {},
      isLoadingRates: {},
      rates: {},
      addressInEdit: {},
      instructionInEdit: '',
      instructionTemplate: {},
      keywords: '',
      isLoading: false,
      templateMenu: false,
      addressMenu: false,
      x: 0,
      y: 0,
      addressInEditType: null,
      shipDateMenu: false,
      orderInEdit: {},
      dangerousGoodsDialog: {
        show: false,
        data: {}
      },
      recommendAddress: {}
    }
  },
  computed: {
    fedexPackagings () {
      return this.$store.getters.fedexPackagings
    },
    referenceOptions () {
      return [
        { text: 'department number', value: 'dept' },
        { text: 'invoice number', value: 'inv' },
        { text: 'po number', value: 'po' }
      ]
    },
    hasHazmatFeatures () {
      return this.visibleBetaFeatures.includes('hazmat')
    },
    isReadonly () {
      return this.orderInEdit.isSupportHazmat && this.addressInEditType === 'from'
    },
    visibleBetaFeatures () {
      return this.$store.getters.visibleBetaFeatures
    },
    env () {
      return process.env.NODE_ENV
    },
    users () {
      return this.$store.getters.users
    },
    skus () {
      let map = new Map()
      if (!this.selectedOrder) return map
      let {items} = this.selectedOrder
      items.forEach(item => {
        let {sku, quantityPurchased, quantityShipped} = item
        if (!map.has(sku)) {
          map.set(sku, 0)
        }
        map.set(sku, map.get(sku) + quantityPurchased - quantityShipped)
      })
      return map
    },
    addedDistributionSet () {
      let set = new Set()
      this.selectedOrder.items.forEach(item => {
        set.add(item.selectedDistribution.fbmKey)
      })
      return set
    },
    siteKeyMap () {
      return this.$store.getters.siteKeyMap
    },
    senderNames () {
      return this.$store.getters.userExtra.senderNames
    },
    packagings () {
      return this.$store.getters.tenantPackagingsWithWarehousePackagings
    },
    packagingMap () {
      return this.$store.getters.packagingMap
    },
    otherServices () {
      return this.$store.getters.otherServices
    },
    addresses () {
      return this.$store.getters.tenantAddresses
    },
    templates () {
      return this.$store.getters.templates
    },
    statesToAbbrev () {
      return this.$store.getters.statesToAbbrev
    },
    states () {
      return this.$store.getters.stateAbbrevs
    },
    allDistributionWithCombinedUpcs () {
      const allDistributionWithCombinedUpcs = [...this.allDistribution, ...this.combinedUpcs]
      return allDistributionWithCombinedUpcs
    },
    combinedUpcs () {
      return this.$store.getters.combinedUpcs.map(item => {
        return {
          ...item,
          quantity: item.totalQuantity
        }
      }) || []
    },
    combinedUpcsByLocation () {
      return this.$store.getters.combinedUpcsByLocation
    },
    allDistribution () {
      return this.$store.getters.allDistribution
    },
    instructions () {
      return this.$store.getters.tenant.instructions || []
    },
    labelServices () {
      return this.$store.getters.labelServices
    },
    shippingServices () {
      return this.selectedOrders.every(order => !order.isMPS) ?
        this.$store.getters.shippingServices.filter(service => !service.isFedexMwt) :
        this.$store.getters.shippingServices.filter(service => service.carrier !== 'USPS')
    },
    carrier () {
      return (this.labelServices.find(service =>
        service.serviceTypes.find(serviceType =>
          this.shippingService === serviceType.value ||
          this.serviceType === service.carrier
        )
      ) || {}).carrier
    },
    systemBalance () {
      return this.$store.getters.systemBalance
    },
    flexibleVars () {
      return this.$store.getters.labelTemplateFlexibleVars
    },
    isMeasurementMetric () {
      return !!this.$store.getters.isMeasurementMetric
    },
    sizeSuffix () {
      return this.isMeasurementMetric ? 'cm' : '"'
    },
    labelStockTypes () {
      return this.$store.getters.labelStockTypes
    },
    isDefaultSnService () {
      return (this.$store.getters.tenantLimitedInfo.defaultSelectedOtherServices || []).includes('SN')
    },
    isDefaultLabelService () {
      return (this.$store.getters.tenantLimitedInfo.defaultSelectedOtherServices || []).includes('label')
    },
    isDefaultPhotoService () {
      return (this.$store.getters.tenantLimitedInfo.defaultSelectedOtherServices || []).includes('photo')
    },
    isShowApplyToAllBtn () {
      return Object.values(this.orders || {}).length > 1
    }
  },
  async mounted () {
    if (!this.isEdit) {
      await this.autoSelectDistribution()
      this.autoSelectTemplate()
      Object.values(this.orders).forEach((order) => {
        this.shippingServiceOnChange(order)
        this.$watch(
          () => order,
          function (val) {
            this.$set(this.errorMessages, order.orderId, '')
            this.$set(this.warningMessages, order.orderId, '')
            if (!Object.values(this.errorMessages).some(item => item)) {
              this.$refs.form.clearAlert()
            }
            order.replacedMemo = this.flexibleVars.reduce((acc, variable) => {
              if (variable === 'quantity') {
                return acc.replace(new RegExp(`#{${variable}}`, 'g'), order.toShip || 0)
              }
              return acc
            }, order.memo || '')
            if (!this.isSupportLabelStockType(order.shippingService)) {
              order.labelStockType = 'STOCK_4X6'
            }

            const toRes = order.buyerPhoneNumber?.match(/^\+\d+\s(.+)\s?ext.\s?(.+)/)
            if (toRes) {
              const [, phone, extension] = toRes
              order.buyerPhoneNumber = phone
                ?.replace(/-/g, '')
                ?.trim()
              order.shipExt = extension?.trim() || ''
            }

            const fromRes = order.shipFrom.phone?.match(/^\+\d+\s(.+)\s?ext.\s?(.+)/)
            if (fromRes) {
              const [, phone, extension] = fromRes
              order.shipFrom.phone = phone
                ?.replace(/-/g, '')
                ?.trim()
              order.shipFrom.extension = extension?.trim() || ''
            }

            const { shippingService } = val
            if (shippingService) {
              const currentService = this.shippingServices.find(item => item.value === shippingService)
              order.isSupportFromExt = currentService?.isSupportFromExt
              order.isSupportToExt = currentService?.isSupportToExt
              order.isOneRate = currentService?.isOneRate
              if (order.isOneRate) {
                order.packageQuantity = 1
              }
            }
          },
          { deep: true, immediate: true }
        )
      })
    }
  },
  methods: {
    getFedexPackagings (order) {
      const currenctShippingService = this.getCurShippingService(order.shippingService)
      if (currenctShippingService?.packageTypeOptions) {
        return this.fedexPackagings.filter(item => currenctShippingService.packageTypeOptions.includes(item.id))
      }
      return this.fedexPackagings
    },
    getStates (shippingService) {
      const curShippingService = this.getCurShippingService(shippingService)
      return this.states.concat(curShippingService.supportParticularStates || [])
    },
    getCurShippingService (shippingService) {
      const labelService = this.labelServices.find(service =>
        service.serviceTypes.some(serviceType => shippingService === serviceType.value)
      ) || {}
      return labelService
    },
    packageQtyChange (order) {
      if (order.isMPS) {
        order.packagingSpecs && order.packagingSpecs.forEach(item => {
          if (item.packageName === order.packaging.packageName) {
            item.packageQuantity = order.packaging.packageQuantity
          }
        })
        order.packageTotal = order.isOneRate ? 1 : order.packagingSpecs?.reduce(
          (total, item) => Math.ceil(total + item.packageQuantity),
          0
        )
        order.weightLbTotal = order.isOneRate ? 0 : order.packagingSpecs?.reduce(
          (total, {weight, packageQuantity}) =>
            addNumbers(total, (weight * packageQuantity)), 0
        )
      }
    },
    weightLbChange (order) {
      if (order.isMPS) {
        order.packagingSpecs && order.packagingSpecs.forEach(item => {
          if (item.packageName === order.packaging.packageName) {
            item.weight = order.weightLb
          }
        })
        order.weightLbTotal = order.packagingSpecs?.reduce(
          (total, {weight, packageQuantity}) =>
            addNumbers(total, (weight * packageQuantity)), 0
        )
      }
    },
    isObject,
    clearFromTemplate (item, value) {
      // reset from
      if (!value) return
      item.shipFrom = {}
      if (item.isMPS) {
        item.items.forEach(item => {
          item.selectedDistribution = {}
          item.toShip = 0
        })
      } else {
        item.selectedDistribution = {}
        item.toShip = 0
      }
    },
    checkAllDistribution () {
      let allDistribution = cloneDeep([...this.allDistribution.filter(item => !item.isCombined), ...this.combinedUpcsByLocation])
      let fbmToShip = {}
      Object.values(this.orders).forEach(order => {
        if (order.isMPS) {
          order.items.forEach(item => {
            let {fbmKey} = item.selectedDistribution
            let {toShip} = item
            if (fbmKey && toShip > 0) {
              if (!fbmToShip[fbmKey]) {
                fbmToShip[fbmKey] = 0
              }
              fbmToShip[fbmKey] += toShip || 0
              let targetDist = allDistribution.find(item => item.fbmKey === fbmKey) || {}
              if (fbmToShip[fbmKey] > (targetDist.quantity || 0)) {
                this.$set(this.errorMessages, order.orderId, this.$t('toShipQtyExceededStorageQty'))
                throw Error('To-ship qty exceeded storage qty.')
              }
            }
          })
        } else {
          order.items.forEach(item => {
            let {fbmKey} = item.selectedDistribution
            let {toShip} = item
            if (fbmKey && toShip > 0) {
              if (!fbmToShip[fbmKey]) {
                fbmToShip[fbmKey] = 0
              }
              fbmToShip[fbmKey] += toShip || 0
              let targetDist = allDistribution.find(item => item.fbmKey === fbmKey) || {}
              if (fbmToShip[fbmKey] > (targetDist.quantity || 0)) {
                this.$set(this.errorMessages, order.orderId, this.$t('toShipQtyExceededStorageQty'))
                throw Error('To-ship qty exceeded storage qty.')
              }
            }
          })
        }
      })
    },
    showTemplateDialog (item) {
      if (item.items.length > 1) return alert(this.$t('multipleItemsTemplateIsNotSupportedThisTime'))
      this.createTemplateDialog = true
      this.selectedOrder = item
      this.templateInEdit = {
        sku: item.items[0].sku
      }
    },
    generateQty (qty) {
      let rtn = []
      for (let i = 0; i <= qty; i++) {
        rtn[i] = i
      }
      return rtn
    },
    removeOrder (item) {
      if (!confirm(this.$t('confirmRemoveOrder'))) return
      this.$delete(this.orders, item.orderId)
    },
    showAddInventoriesDialog (order, sku) {
      this.selectedOrder = order
      if (order.isMPS) {
        this.selectedOrder = {...order, items: order.items.filter(item => item.sku === sku)}
      }
      this.addInventoriesDialog = true
    },
    showAddProductDialog (product) {
      this.productInEdit = product
      this.addProductDialog = true
    },
    async addProduct (distribution, isAuto = false) {
      const orderId = this.selectedOrder.orderId
      const shipFrom = await this.$store.dispatch('getShipFrom', distribution)
      let orderShipFrom = Object.entries(this.orders[orderId]?.shipFrom || {})
      if (orderShipFrom.length && this.orders[orderId].isMPS) {
        let isSame = Object.entries(shipFrom).every(([key, val]) => {
          return orderShipFrom.every(([orderKey, orderVal]) => {
            if (key === orderKey) {
              return val === orderVal
            }
            return true
          })
        })
        if (!isSame) return alert(this.$t('CannotDifferentWarehouse'))
      }
      if (this.orders[orderId].items.length >= 1 || this.orders[orderId].isMPS) {
        let isSelect = false
        this.orders[orderId].items.forEach((item, index) => {
          const {quantityPurchased, quantityShipped, sku} = item
          if (distribution.sku.includes(sku)) {
            this.$set(this.orders[orderId].items[index], 'selectedDistribution', {
              ...distribution,
              shipmentProductKey: `${distribution.warehouseSite}${distribution.id}`
            })
            this.$set(this.orders[orderId].items[index], 'toShip', Math.min(distribution.quantity, quantityPurchased - quantityShipped))
            isSelect = true
          }
        })
        if (!isSelect && !isAuto) {
          alert(this.$t('skuDifferent'))
          return
        }
      } else {
        const {quantityPurchased, quantityShipped} = this.orders[orderId].items[0]
        this.$set(this.orders[orderId], 'toShip', Math.min(distribution.quantity, quantityPurchased - quantityShipped))
        this.$set(this.orders[orderId], 'selectedDistribution', {
          ...distribution,
          shipmentProductKey: `${distribution.warehouseSite}${distribution.id}`
        })
      }
      this.$set(this.orders[orderId], 'shipFrom', { ...shipFrom, warehouseKey: distribution.warehouseKey, key: distribution.key })
      const isMeasurementMetric = distribution.unit === 'metric'
      const order = this.orders[orderId]
      const shippingRanges = buildShippingRanges(distribution, distribution.unit, this.buildMeasurement)
      const targetRange = findShippingRangeByToShip(order.toShip, shippingRanges)
      if (targetRange) {
        const {height, length, width, weight} = targetRange
        this.$set(order, 'packaging', {
          ...this.convertPackagingSize({ height: height, length: length, width: width }, isMeasurementMetric)
        })
        this.$set(order, 'weightLb', this.convertWeight(toMoney(weight * order.toShip), isMeasurementMetric))
        this.$set(order, 'isMeasurementMetric', isMeasurementMetric)
      }
      this.addressInEdit = {}
    },
    deleteProduct (distribution) {
      const orderId = this.selectedOrder.orderId
      if (this.orders[orderId].isMPS) {
        this.orders[orderId].items.forEach((item, index) => {
          if (distribution.sku.includes(item.sku)) {
            this.$set(this.orders[orderId].items[index], 'toShip', 0)
            this.$set(this.orders[orderId].items[index], 'selectedDistribution', {})
            if (index === this.orders[orderId].items.length - 1) {
              this.$set(this.orders[orderId], 'shipFrom', {})
            }
          }
        })
      } else {
        this.orders[orderId].items.forEach((item, index) => {
          if (distribution.sku.includes(item.sku)) {
            this.$set(this.orders[orderId].items[index], 'toShip', 0)
            this.$set(this.orders[orderId].items[index], 'selectedDistribution', {})
            if (index === this.orders[orderId].items.length - 1) {
              this.$set(this.orders[orderId], 'shipFrom', {})
            }
          }
        })
        this.$set(this.orders[orderId], 'selectedDistribution', {})
        this.$set(this.orders[orderId], 'toShip', 0)
      }
    },
    validDangerousGoodsInfo (order, isSupportDangerousGoods = false) {
      if (!isSupportDangerousGoods) return

      const {
        weightLb,
        hazMatsInfo,
        dangerousGoods,
        shippingService,
        orderId,
        isOz,
        dryIceDetail: {
          weight,
          unit
        }
      } = order

      const orderWeight = isOz ? (weightLb / 16) : weightLb
      const isSupportHazmatService = this.labelServices.some(service => {
        const serviceType = service.serviceTypes.find(serviceType => shippingService === serviceType.value)
        return serviceType && serviceType.isSupportDangerousGoods
      })

      let errorMsg = null
      if (!dangerousGoods) errorMsg = this.$t('invalidDangerousGoods')
      if (!isSupportHazmatService) errorMsg = this.$t('shippingServiceNotSupportDangerousGoods')
      if (
        (dangerousGoods === 'BATTERY' && orderWeight < this.totalBatteryWeight(hazMatsInfo)) ||
        (dangerousGoods === 'DRY_ICE' && orderWeight < +this.convertWeight(weight, unit === 'KG'))
      ) {
        errorMsg = this.$t('dangerousGoodsExceedsWeight')
      }

      if (errorMsg) {
        this.$set(this.errorMessages, orderId, errorMsg)
        throw Error(`${this.$t('order')}:${orderId} ${errorMsg}`)
      }
    },
    extractLabelPayload (item) {
      let {
        carrier,
        signature,
        weightLb,
        packaging: pkging,
        shipDate,
        shippingService,
        senderName,
        fromCompanyName = '',
        recipientName,
        toCompanyName = '',
        shipAddress1,
        shipAddress2,
        shipCity,
        shipPostalCode,
        shipState,
        shipExt,
        orderId,
        shipFrom,
        isOz,
        enableInsured = false,
        insuredValue,
        buyerPhoneNumber,
        replacedMemo,
        reference = '',
        dangerousGoods,
        hazMatsInfo,
        offerorName,
        emergencyContactNumber,
        dryIceDetail,
        labelStockType,
        items = [],
        isMPS = false,
        referenceValue,
        referenceName,
        platform,
        memo,
        packageType,
        isOneRate,
        isSupportFromExt,
        isSupportToExt
      } = item
      const states = this.getStates(shippingService)
      if ([shipState, shipFrom.state].some(item => !states.includes(item))) {
        throw Error(`State is not in ${states.join(', ')}`)
      }
      if (recipientName.length > 35) throw Error(`Recipient name are limited to less or equal to 35 characters.`)
      if (items.some(item => Object.keys(item.selectedDistribution) <= 1)) throw Error(`Please select item for this order.`)
      const isSupportDangerousGoods = this.isSupportDangerousGoods(item)
      this.validDangerousGoodsInfo(item, isSupportDangerousGoods)
      const isSupportLabelStockType = this.isSupportLabelStockType(shippingService)
      let packaging = {
        ...pkging,
        signature,
        insuredValue: enableInsured ? insuredValue : 0,
        weight: isOz ? (weightLb / 16) : weightLb
      }
      if (this.getCurShippingService(shippingService) && referenceName) {
        packaging[referenceName] = referenceValue
      }
      const [serviceType, channel = 'GENERAL'] = shippingService.split(' - ')
      const isBattery = dangerousGoods === 'BATTERY'

      const payload = {
        carrier,
        packaging,
        packages: isMPS ? item.packagingSpecs.reduce((total, pkg) => {
          let {packageQuantity, packageName, ...rest} = pkg
          while (packageQuantity > 0) {
            total.push({...Object.assign(packaging, rest, {sequenceNumber: total.length + 1})})
            packageQuantity -= 1
          }
          return total
        }, []) : [{ ...packaging, sequenceNumber: 1 }],
        from: {
          ...shipFrom,
          fullName: senderName,
          company: fromCompanyName
        },
        to: {
          fullName: recipientName,
          address1: shipAddress1,
          address2: shipAddress2 || '',
          city: shipCity,
          zipCode: shipPostalCode?.trim() || '',
          state: shipState,
          phone: buyerPhoneNumber,
          company: toCompanyName,
          extension: shipExt || ''
        },
        signature,
        insuredValue: enableInsured ? insuredValue : 0,
        shipDate,
        shippingService,
        serviceType,
        channel,
        weight: isOz ? (weightLb / 16) : weightLb,
        note: reference || `Label for order ${orderId}`,
        memo: replacedMemo || memo || '',
        isMeasurementMetric: this.isMeasurementMetric,
        isSupportHazmat: isSupportDangerousGoods
      }
      if (!isSupportFromExt) {
        delete payload.from.extension
      }
      if (!isSupportToExt) {
        delete payload.to.extension
      }
      if (platform?.toUpperCase() === 'AMAZON') {
        const toRes = payload.to.phone.match(/^\+\d+\s(.+)\s?ext.\s?(.+)/)
        if (toRes) {
          const [, phone] = toRes
          payload.to.phone = phone
            ?.replace(/-/g, '')
            ?.trim()
          // payload.to.extension = extension
          // ?.trim() || ''
        } else {
          // delete payload.to.extension
        }
        const fromRes = payload.from.phone.match(/^\+\d+\s(.+)\s?ext.\s?(.+)/)
        if (fromRes) {
          const [, phone] = fromRes
          payload.from.phone = phone
            ?.replace(/-/g, '')
            ?.trim()
          // payload.from.extension = extension
          // ?.trim() || ''
        } else {
          // delete payload.from.extension
        }
      }
      if (isSupportLabelStockType) payload.labelStockType = labelStockType
      if (isSupportDangerousGoods) {
        payload.dangerousGoods = dangerousGoods
        if (isBattery) {
          Object.assign(payload, {
            hazMatsInfo,
            offerorName,
            emergencyContactNumber
          })
        } else if (dangerousGoods === 'DRY_ICE') {
          Object.assign(payload, {
            dryIceDetail
          })
        }
      }
      if (isOneRate) {
        // const packageWeight = this.fedexPackagings.find(pkg => pkg.value === packagingType).weight
        const { weight, length, width, height, packageName, packageQuantity, ...rest } = payload.packaging
        // payload.weight = packageWeight
        // rest.weight = packageWeight
        rest.sequenceNumber = 1
        payload.packages = [rest]
        payload.packaging = rest
        payload.packageType = packageType
        payload.pricingOption = PRICING_OPTIONS.ONE_RATE
      }
      return payload
    },
    isHasDropshippingOrgByWarehouse (warehouseKey) {
      const {featureInboundForecastDropshipping = []} = this.$store.getters.tenant || {}
      return featureInboundForecastDropshipping.includes(warehouseKey)
    },
    extractShipmentPayload (item) {
      let {
        selectedDistribution,
        shippingService,
        isExpedited,
        selectedOtherServices,
        instruction,
        items = []
      } = item
      const warehouseKey = items[0].selectedDistribution?.warehouseKey || selectedDistribution.warehouseKey
      const isDropshippingPackage = this.isHasDropshippingOrgByWarehouse(warehouseKey)
      const products = items.filter(item => JSON.stringify(item.selectedDistribution) !== '{}').map(({selectedDistribution, toShip}) => {
        return {...selectedDistribution, toShip}
      })
      let billingWeight = 0
      return {
        products: products,
        selectedOrder: item,
        selectedProducts: items.map(({selectedDistribution, toShip}) => {
          return {...selectedDistribution, toShip}
        }),
        userName: items[0].selectedDistribution?.userName || selectedDistribution.userName,
        userKey: items[0].selectedDistribution?.uid || selectedDistribution.uid,
        warehouseKey: items[0].selectedDistribution?.warehouseKey || selectedDistribution.warehouseKey || '',
        status: 'created',
        packageQty: 1,
        carrier: shippingService,
        isExpedited,
        otherServices: isDropshippingPackage ? [] : selectedOtherServices,
        instruction,
        siteKey: items[0].selectedDistribution?.warehouseSite || selectedDistribution.warehouseSite,
        orderProcessTime: item.orderProcessTime || new Date(),
        billingWeight: billingWeight || 0,
        isDropshippingPackage: isDropshippingPackage
      }
    },
    getRate (orderId) {
      try {
        const relatedFormKeys = Object.keys(this.$refs)
          .filter(item => [
            `form-${orderId}-1`,
            `form-${orderId}-2`,
            `form-${orderId}-3`
          ].includes(item) || this.orders[orderId].items.some(row => `form-${orderId}-0-${row.orderItemId}` === item))

        const validateResults = relatedFormKeys.map(key => this.$refs[key].validate?.() || this.$refs[key][0]?.validate?.())
        if (validateResults.some(item => !item)) return Promise.resolve()

        let payload = this.extractLabelPayload(this.orders[orderId])
        this.systemBalance.discount && (payload.discount = this.systemBalance.discount)
        this.$set(this.isLoadingRates, orderId, true)
        this.$set(this.rates, orderId, null)
        this.$set(this.recommendAddress, orderId, null)
        return this.$store.dispatch('getRates', payload)
          .then(rtn => {
            // if (rtn.data.notMatch) {
            //   this.$set(this.warningMessages, orderId, this.$t('orderNotMatch'))
            // }
            if (rtn.data.recommendAddress) {
              let {
                address1,
                address2,
                city,
                state,
                zipCode
              } = rtn.data.recommendAddress
              this.$set(this.recommendAddress, orderId, {
                address1,
                address2,
                city,
                state,
                zipCode
              })
            }
            this.$set(this.rates, orderId, this.setRates(rtn.data))
          })
          .catch(error => {
            return this.$set(this.errorMessages, orderId, error.message)
          })
          .finally(() => {
            this.$set(this.isLoadingRates, orderId, false)
          })
      } catch (error) {
        this.$set(this.errorMessages, orderId, error.message)
      }
    },
    randomNumGenerator (length) {
      let rtn = ''
      for (let i = 0; i < length; i++) {
        rtn += Math.floor(Math.random() * 10)
      }
      return rtn
    },
    async onSubmitted () {
      this.isLoading = true
      let labels
      try {
        this.checkAllDistribution()
        const originOrderQty = Object.keys(this.orders).length
        const validatedOrderKeys = Object.keys(this.orders)
          .map(orderId => {
            const relatedFormKeys = Object.keys(this.$refs)
              .filter(item => [
                `form-${orderId}-1`,
                `form-${orderId}-2`,
                `form-${orderId}-3`
              ].includes(item) || this.orders[orderId].items.some(row => `form-${orderId}-0-${row.orderItemId}` === item))
            const validateResults = relatedFormKeys.map(key => this.$refs[key].validate?.() || this.$refs[key][0]?.validate?.())
            if (validateResults.some(item => !item)) return ''
            return orderId
          })
          .filter(orderId => !!orderId)
        if (validatedOrderKeys.length < originOrderQty) throw Error(`Note: Please check errors.`)

        const randomIds = uniqueIdGenerator(validatedOrderKeys.length)
        const errorItems = []
        labels = validatedOrderKeys.map((orderId, index) => {
          let order = this.orders[orderId]
          const {items, toShip, storeId = '', storeName = '', platform} = order
          const requestId = order.requestId || (randomIds[index] + `A${this.randomNumGenerator(2)}`)
          const shipmentId = requestId.split('A')[0]
          try {
            const payload = this.extractLabelPayload(order)
            const res = {
              ...payload,
              requestId,
              shipmentId,
              isMPS: order.isMPS || false,
              isApiOrder: order.isApiOrder || false,
              orderKey: order._key,
              keywords: this.keywords,
              order: {
                orderId,
                items: items.map(({ selectedDistribution, toShip, ...rest }) => {
                  return rest
                }),
                toShip,
                storeId,
                storeName,
                platform
              }
            }
            if (res.isApiOrder && order.platform?.toUpperCase() === 'TIKTOK') {
              // single item
              const { items } = order
              if (items[0].toShip !== items[0].quantityPurchased) {
                errorItems.push(orderId)
              }
            }
            return res
          } catch (error) {
            this.$set(this.errorMessages, orderId, error.message)
            throw Error(`Note: Please check remaining orders' error.`)
          }
        })

        const shipments = []
        let isError = false
        labels.forEach(label => {
          const orderId = label.orderKey.split('-').slice(1).join('-')
          const res = {
            ...this.extractShipmentPayload(this.orders[orderId]),
            _key: label.shipmentId
          }
          const [firstProduct, ...otherProducts] = res.products
          const { warehouseSite } = firstProduct
          if (otherProducts.some(product => product.warehouseSite !== warehouseSite)) {
            this.$set(this.errorMessages, orderId, 'Must the same warehouse address')
            isError = true
          } else {
            shipments.push(res)
          }
        })
        if (isError) {
          throw Error(`Note: Please check remaining orders' error.`)
        }

        if (errorItems.length) {
          errorItems.forEach(item => {
            this.$set(this.errorMessages, item, `If you need partial delivery, please split the order first.`)
          })
          throw Error(`Note: Please check remaining orders' error.`)
        }

        await this.$store.dispatch('addOrderShipment', {
          labels,
          shipments,
          keywords: this.keywords
        })

        this.$emit('submitted')
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        if (error.message === 'endpoint-request-timed-out') {
          labels && (labels.forEach(label => {
            const {requestId, orderKey} = label
            const orderId = orderKey.split('-').slice(1).join('-')
            this.orders[orderId].requestId = requestId
          }))

          throw Error('Endpoint request timed out. Please retry.')
        } else if (error.message === 'Package 1 - Invalid number of commodities in hazardous commodity content') {
          throw Error(this.$t('invalidNumberOfHazmat'))
        }
        throw error
      }
    },
    loadPackagesFromOldFormat (template) {
      const {
        packaging,
        weightLb,
        length: templateLength,
        width: templateWidth,
        height: templateHeight,
        isMeasurementMetric: isWeightMeasurementMetric = false
      } = template

      const targetPackaging = this.packagingMap.get(packaging) || {}
      const {
        height: pkgHeight,
        length: pkgLength,
        width: pkgWidth,
        isMeasurementMetric: isPackagingMeasurementMetric = false,
        ...pkgRest
      } = targetPackaging

      return {
        packaging: {
          ...this.convertPackagingSize({
            height: pkgHeight || templateHeight,
            length: pkgLength || templateLength,
            width: pkgWidth || templateWidth
          }, isPackagingMeasurementMetric),
          ...pkgRest
        },
        weightLb: this.convertWeight(weightLb, isWeightMeasurementMetric)
      }
    },
    loadPackagesFromNewFormat (template) {
      const {packages, isMeasurementMetric: isWeightMeasurementMetric = false} = template
      const firstPackage = packages[0] || {}
      const {
        packaging,
        weight,
        length,
        width,
        height
      } = firstPackage

      let result = {
        weightLb: this.convertWeight(weight || 0, isWeightMeasurementMetric)
      }

      if (packaging) {
        const targetPackaging = this.packagingMap.get(packaging) || {}
        const {
          height: pkgHeight,
          length: pkgLength,
          width: pkgWidth,
          isMeasurementMetric: isPackagingMeasurementMetric = false,
          ...packagingRest
        } = targetPackaging

        result.packaging = {
          ...this.convertPackagingSize({
            height: pkgHeight || height,
            length: pkgLength || length,
            width: pkgWidth || width
          }, isPackagingMeasurementMetric),
          ...packagingRest
        }
      } else {
        result.packaging = this.convertPackagingSize({length, width, height}, false)
      }

      return result
    },
    onSelectTemplate (orderId, event) {
      const {from = {}, createTime, selectedOtherServices, lastModifiedTime, memo, sku, packaging, weightLb, labelStockType, packages, ...rest} = event
      let replacedMemo = this.flexibleVars.reduce((acc, variable) => {
        if (variable !== 'quantity') {
          return acc.replace(new RegExp(`#{${variable}}`, 'g'), this.orders[orderId][variable])
        }
        return acc
      }, memo)
      Object.assign(this.orders[orderId], {
        senderName: from.fullName,
        memo: replacedMemo,
        fromCompanyName: from.company,
        isMeasurementMetric: this.isMeasurementMetric,
        labelStockType: labelStockType || 'STOCK_4X6',
        ...rest
      })

      if (!!rest.dangerousGoods && this.hasHazmatFeatures && !this.orders[orderId].isSupportHazmat) {
        this.orders[orderId].isSupportHazmat = true
        this.clearFromTemplate(this.orders[orderId], true)
      }

      let packageData
      if (packages && Array.isArray(packages) && packages.length > 0) {
        packageData = this.loadPackagesFromNewFormat(event)
      } else {
        packageData = this.loadPackagesFromOldFormat(event)
      }

      this.$set(this.orders[orderId], 'packaging', packageData.packaging)
      this.$set(this.orders[orderId], 'weightLb', packageData.weightLb)

      this.$nextTick(() => {
        this.orders[orderId].selectedOtherServices = [...selectedOtherServices]
        this.shippingServiceOnChange(this.orders[orderId])
      })
    },
    async autoSelectDistribution () {
      const priorityWarehouseKeys = ['gwzhvO7mMKeQuwklLLzR', 'kTkQBnEhi0hJwTwrIJ1K']
      const allDistribution = [...this.allDistribution.filter(item => !item.isCombined), ...this.combinedUpcsByLocation]
      const distributionRemainQuantity = new Map()
      for (let order of Object.values(this.orders)) {
        let quantityPurchased = order.items[0].quantityPurchased
        let target = allDistribution.filter(dist => {
          if (dist.sku && dist.sku.includes(order.items[0].sku) && priorityWarehouseKeys.includes(dist.warehouseKey) && (!distributionRemainQuantity.has(dist) || distributionRemainQuantity.get(dist))) {
            const currentRemain = distributionRemainQuantity.get(dist) || dist.quantity
            const afterPurchaseRemain = currentRemain - quantityPurchased
            if (afterPurchaseRemain >= 0) {
              distributionRemainQuantity.set(dist, afterPurchaseRemain)
              return true
            }
          }
        })
        if (!target.length || target.length !== order.items.length) {
          if (order.isMPS) {
            target = allDistribution.filter(dist => {
              if (dist.sku && order.items.some(item => dist.sku.includes(item.sku) && (!distributionRemainQuantity.has(dist) || distributionRemainQuantity.get(dist)))) {
                const currentRemain = distributionRemainQuantity.get(dist) || dist.quantity
                const afterPurchaseRemain = currentRemain - quantityPurchased
                if (afterPurchaseRemain >= 0) {
                  distributionRemainQuantity.set(dist, afterPurchaseRemain)
                  return true
                }
              }
            })
            if (target.length >= order.items.length) {
              let diffSite = {}

              target.forEach(item => {
                if (!diffSite[item.warehouseSite]) {
                  item.siteNum = 1
                  diffSite[item.warehouseSite] = item
                } else {
                  diffSite[item.warehouseSite].siteNum += 1
                }
              })
              let diffSiteArray = Object.entries(diffSite)
              if (diffSiteArray.every(([key, value]) => value.siteNum === 1)) target = [diffSiteArray[0][1]]
              else {
                target = target.filter(item => item.warehouseSite === diffSiteArray.sort(([aKey, aVal], [bKey, bVal]) => bVal.siteNum - aVal.siteNum)[0][0])
              }
            }
          } else {
            target = allDistribution.filter(dist => {
              if (dist.sku && order.items.some(item => dist.sku.includes(item.sku) && (!distributionRemainQuantity.has(dist) || distributionRemainQuantity.get(dist)))) {
                const currentRemain = distributionRemainQuantity.get(dist) || dist.quantity
                const afterPurchaseRemain = currentRemain - quantityPurchased
                if (afterPurchaseRemain >= 0) {
                  distributionRemainQuantity.set(dist, afterPurchaseRemain)
                  return true
                }
              }
            })
            if (target.length >= order.items.length) {
              let diffSite = {}

              target.forEach(item => {
                if (!diffSite[item.warehouseSite]) {
                  item.siteNum = 1
                  diffSite[item.warehouseSite] = item
                } else {
                  diffSite[item.warehouseSite].siteNum += 1
                }
              })
              let diffSiteArray = Object.entries(diffSite)
              const targetSite = diffSiteArray.find(item => item[1].siteNum === order.items.length)
              if (targetSite) {
                target = target.filter(item => item.warehouseSite === targetSite[0])
              } else {
                if (diffSiteArray.every(([key, value]) => value.siteNum === 1)) target = [diffSiteArray[0][1]]
                else {
                  target = target.filter(item => item.warehouseSite === diffSiteArray.sort(([aKey, aVal], [bKey, bVal]) => bVal.siteNum - aVal.siteNum)[0][0])
                }
              }
            }
          }
        }
        if (target) {
          this.selectedOrder = order
          if (Array.isArray(target)) {
            for (let item of target) {
              await this.addProduct(item, true)
            }
          } else {
            await this.addProduct(target, true)
          }
          this.selectedOrder = {}
        }
      }

      this.selectedOrder = {}
    },
    autoSelectTemplate () {
      Object.values(this.orders).forEach(order => {
        // let target = this.templates.find(template => order.items.some(item => item.sku === template.sku)
        const skuMatchedTemplates = this.templates.filter(template => order.items.some(item => item.sku === template.sku || template.sku?.split(',').includes(item.sku)))
        const exactlyMatchedTemplates = skuMatchedTemplates.filter(template => order.items.some(item => +item.quantityPurchased === +template.quantity && +item.quantityPurchased <= (template.quantityLimit || 0)))
        const adapteOldData = skuMatchedTemplates.filter(template => +template.quantity === 1 || !template.quantity)
        let target = exactlyMatchedTemplates.length ? exactlyMatchedTemplates[0] : (adapteOldData.length ? adapteOldData[0] : skuMatchedTemplates.length ? skuMatchedTemplates[0] : '')
        if (target && !order.isMPS) {
          this.orders[order.orderId].template = target
          this.onSelectTemplate(order.orderId, target)
        }
        if (!target) {
          this.$nextTick(() => this.autoAddSnServiceFromSetting())
        }
      })
    },
    onCreateTemplate (template) {
      this.orders[this.selectedOrder.orderId].template = template
      this.onSelectTemplate(this.selectedOrder.orderId, template)
    },
    saveAddressFrom () {
      if (JSON.stringify(this.addressInEdit) !== '{}' && this.$refs[`form-address`].validate()) {
        this.orderInEdit.shipFrom = this.addressInEdit
        this.addressInEdit = {}
        this.addressMenu = false
      }
    },
    saveAddressTo () {
      if (JSON.stringify(this.addressInEdit) !== '{}' && this.$refs[`form-address`].validate()) {
        const {
          name: recipientName,
          address1: shipAddress1,
          address2: shipAddress2,
          city: shipCity,
          zipCode: shipPostalCode,
          state: shipState,
          phone: buyerPhoneNumber,
          extension: shipExt,
          toCompanyName
        } = this.addressInEdit
        Object.assign(this.orderInEdit, {
          recipientName,
          shipAddress1,
          shipAddress2,
          shipCity,
          shipPostalCode,
          shipState,
          buyerPhoneNumber,
          toCompanyName,
          shipExt
        })
        this.addressMenu = false
      }
    },
    changeInstruction (e) {
      this.instructionInEdit = e.content
    },
    setEnableInsured (item) {
      item.enableInsured = this.getLabelServiceSettingByCarrierAndServiceTypeValue(item.carrier, item.shippingService).enableInsured
    },
    getCarrier (item) {
      return (this.labelServices.find(service =>
        service.serviceTypes.findIndex(serviceType =>
          item.shippingService === serviceType.value
        ) >= 0
      ) || {}).carrier
    },
    checkSignatureValue (item) {
      const signatureOpts = this.getLabelServiceSettingByCarrierAndServiceTypeValue(item.carrier, item.shippingService).signatureOptions || []
      let defaultValue = signatureOpts?.[0]?.value || ''
      for (let option of signatureOpts) {
        if (option.default) defaultValue = option.value
        if (option.value === item.signature) return
      }
      item.signature = defaultValue
    },
    shippingServiceOnChange (item) {
      item.carrier = this.getCarrier(item)
      this.setEnableInsured(item)
      this.checkSignatureValue(item)
      item.insuredValue = item.enableInsured ? item.insuredValue : 0
    },
    setRates (data) {
      const {postageAmount, ...surcharges} = data.amountDetails
      const surcharge = Object.values(surcharges).reduce((a, b) => toMoney(a + b), 0)
      return {
        total: toMoney(postageAmount + surcharge),
        rate: postageAmount,
        surcharge,
        isResidential: data.isResidential
      }
    },
    showInstruction (e, order) {
      e.preventDefault()
      this.templateMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.templateMenu = true
      })
      this.orderInEdit = order
      this.instructionInEdit = order.instruction
      this.instructionTemplate = {}
    },
    showEditAddressTo (e, order) {
      e.preventDefault()
      this.addressMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.addressMenu = true
      })
      const {
        recipientName: name,
        shipAddress1: address1,
        shipAddress2: address2,
        shipCity: city,
        shipPostalCode: zipCode,
        shipState: state,
        buyerPhoneNumber: phone,
        toCompanyName,
        shipExt
      } = order
      this.addressInEdit = {
        name,
        address1,
        address2,
        city,
        zipCode,
        state,
        phone,
        toCompanyName,
        extension: shipExt
      }
      this.orderInEdit = order
      this.addressInEditType = 'to'
    },
    showEditAddressFrom (e, order) {
      e.preventDefault()
      this.addressMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.addressMenu = true
      })
      this.addressInEdit = {...order.shipFrom}
      this.orderInEdit = order
      this.addressInEditType = 'from'
    },
    showEditDate (e, order) {
      e.preventDefault()
      this.shipDateMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.shipDateMenu = true
      })
      this.orderInEdit = order
    },
    goToGoogleMapLink () {
      gotoGoogleMap(this.addressInEdit)
    },
    onSelectPackaging (e, item) {
      const {height, length, width, weight, isMeasurementMetric = false} = e
      this.$set(item, 'packaging', this.convertPackagingSize({height, length, width}, isMeasurementMetric))
      if (weight) {
        this.$set(item, 'weightLb', this.convertWeight(weight, isMeasurementMetric))
      }
    },
    getLabelServiceSettingByCarrierAndServiceTypeValue (carrier, serviceTypeValue) {
      return this.$store.getters.getLabelServiceSettingByCarrierAndServiceTypeValue(carrier, serviceTypeValue)
    },
    isSupportDangerousGoods ({ isSupportHazmat }) {
      return this.hasHazmatFeatures && isSupportHazmat
    },
    isSupportLabelStockType (shippingService) {
      const labelService = this.labelServices.find(service =>
        service.serviceTypes.some(serviceType => shippingService === serviceType.value)
      ) || {}
      return labelService.isSupportLabelStockType
    },
    showDangerousGoodsDialog (data) {
      Object.assign(this.dangerousGoodsDialog, {
        show: true,
        data: { ...data }
      })
    },
    onSubmittedDangerousGoods () {
      const {
        orderId,
        dangerousGoods = '',
        hazMatsInfo = [],
        offerorName,
        emergencyContactNumber,
        dryIceDetail = {}
      } = this.dangerousGoodsDialog.data
      const isBattery = dangerousGoods === 'BATTERY'
      if (!orderId) throw Error(this.$t('missingOrderId'))
      if (isBattery && hazMatsInfo.length < 1) throw Error(this.$t('fillInAtLeastOneHazMatInformation'))
      Object.assign(this.orders[orderId], {
        dangerousGoods,
        hazMatsInfo,
        offerorName,
        emergencyContactNumber,
        dryIceDetail
      })
      this.dangerousGoodsDialog.data = {}
    },
    totalBatteryWeight (data) {
      return data.reduce((total, battery) => {
        total += +this.convertWeight(battery.commodityWeight, battery.isMeasurementMetric)
        return total
      }, 0)
    },
    applyPhoneNumberToAll () {
      const { phone = '' } = this.addressInEdit
      if (phone) {
        this.orders = Object.fromEntries(Object.entries(this.orders).map(([key, value]) => {
          if (value && value.shipFrom && Object.keys(value.shipFrom).length) {
            value.shipFrom.phone = phone
          }
          return [key, value]
        }))
      }
    },
    autoAddSnServiceFromSetting () {
      this.orders = Object.fromEntries(Object.entries(this.orders).map(([key, value]) => {
        const { selectedOtherServices = [] } = value
        if (!selectedOtherServices.includes('SN') && this.isDefaultSnService) {
          value.selectedOtherServices.push('SN')
        }
        if (!selectedOtherServices.includes('photo') && this.isDefaultPhotoService) {
          value.selectedOtherServices.push('photo')
        }
        if (!selectedOtherServices.includes('label') && this.isDefaultLabelService) {
          value.selectedOtherServices.push('label')
        }
        return [key, value]
      }))
    },
    useRecommendAddress (orderId) {
      if (!this.recommendAddress[orderId]) return
      const { address1, address2, city, state, zipCode } = this.recommendAddress[orderId]
      this.$set(this.orders[orderId], 'shipAddress1', address1)
      this.$set(this.orders[orderId], 'shipAddress2', address2)
      this.$set(this.orders[orderId], 'shipCity', city)
      this.$set(this.orders[orderId], 'shipPostalCode', zipCode)
      this.$set(this.orders[orderId], 'shipState', state)
    },
    formatRecommendAddress (recommendAddress) {
      if (!recommendAddress) return ''
      const { address1, address2, city, state, zipCode } = recommendAddress
      return [address1, address2, city, state, zipCode].filter(item => item).join(',')
    }
  },
  props: {
    value: Boolean,
    selectedOrders: {
      type: Array,
      default: () => []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BuyShippingPopup.vue